import { Component, OnInit, ElementRef, Directive, Input, ViewChild, ViewChildren } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PreferenceService } from '../../Services/preferenceservice.service';
import { CheckAuth } from '../../Services/UtilityService';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
//import { debounce } from 'rxjs/operator/debounce';
import { ProgressBarModule } from 'primeng/progressbar';
import { CompanyServices } from '../../Services/CompanyServices';
import { LoginComponent } from '../login/login.component';
import { HazardServices } from '../../Services/HazardServices';
import { UserLocationModel } from '../../Models/UserLocationModel';

@Component({
  templateUrl: './BasicPreference.component.html'
})

export class BasicPreference implements OnInit {
  tokenKey: string = "";
  userID: number = 0;
  basicinfoForm: FormGroup;
  locationForm: FormGroup;
  errorMessage: any;
  isshowerror: boolean;
  locationname: string;
  logofile: any;
  locationlist: UserLocationModel[];
  public questionList: QuestionData[] | undefined;
  @ViewChildren('myInput') mc;
  @ViewChildren('myhdnInput') mhc;
  public anslist = [];
  selectedFiles: FileList;
  currentFileUpload: File;
  isShowprogressSpinner: boolean;
  blockedPanel: boolean = false;
  blockedDocument: boolean = false;
  blockDocument() {
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.blockedDocument = false;
  }

  value: number = 0;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
    private _preferenceService: PreferenceService, private _router: Router, private elRef: ElementRef, private checkAuth: CheckAuth, private companyServices: CompanyServices, private logincomp: LoginComponent, private hazardServices: HazardServices) {
    this.userID = +this.logincomp.GetplainText(sessionStorage.getItem('UserId'));

    this.basicinfoForm = this._fb.group({
      UserPreferenceBasicInfoId: 0,
      CompanyName: [''],
      CompanyAddress: [''],
      City: [''],
      State: [''],
      Phone: [''],
      UserId: this.userID,
      CreatedBy: this.userID
    })

    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.GetCompany();
    this.isshowerror = false;
    this.isShowprogressSpinner = false;
    this.unblockDocument();
    this.locationlist = [{ locationId: 0, location: '', displayOrder: 0, userId: this.userID, createdBy: this.userID, modifiedBy: this.userID, isDeleted: false }];
  }

  addlocation() {
    let displayorder = this.locationlist.length + 1;
    this.locationlist.push({ locationId: 0, location: '', displayOrder: displayorder, userId: this.userID, createdBy: this.userID, modifiedBy: this.userID, isDeleted: false });
  }
  templist = [];
  removelocation(ind) {
    this.locationlist.splice(ind, 1);

    //// Reset Order Number
    //for (let result of this.locationlist) {
    //    let displayorder = this.templist.length + 1;
    //    this.templist.push({ LocationId: result.LocationId, Location: result.Location, DisplayOrder: displayorder });
    //}
    //this.locationlist = this.templist;
  }

  save() {
    debugger;
    this.isShowprogressSpinner = true;
    this.blockDocument();

    // Save Basic Information
    this._preferenceService.savebasicinfo(this.basicinfoForm.value, this.tokenKey)
      .subscribe(data => {
        if (data.status == 'Success') {
        }
        else {
          this.errorMessage = data.status;
          this.isshowerror = true;
          this.isShowprogressSpinner = false;
          this.unblockDocument();
        }
      })

    // Remove duplicate location and blank data.       
    this.locationlist = this.locationlist.filter((thing, index, self) =>
      index === self.findIndex((t) => (
        t.location === thing.location && t.location !== ""
      ))
    )

    // Save Location
    if (this.locationlist.length > 1) {
      this._preferenceService.savelocation(this.locationlist, this.tokenKey)
        .subscribe(data => {
          if (data.status == 'Success') {
          }
          else {
            this.errorMessage = data.status;
            this.isshowerror = true;
            this.isShowprogressSpinner = false;
            this.unblockDocument();
          }
        })
    }

    //console.log(this.vc.first.nativeElement);
    var controllist = document.getElementsByClassName("ehs_textrow");
    this.anslist = [];
    for (let i = 0; i < this.mc._results.length; i++) {
      let questionid = 0;
      let Ans;
      let LogoFile;
      if (this.mc._results[i].nativeElement.type == 'select-one') {
        if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
          questionid = this.mc._results[i].nativeElement.id.split('_')[1]
        }
        Ans = this.mc._results[i].nativeElement.value;
      }
      else if (this.mc._results[i].nativeElement.type == 'radio') {
        if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
          questionid = this.mc._results[i].nativeElement.id.split('_')[1]
        }
        Ans = "";
        if (this.mc._results[i].nativeElement.checked) {
          Ans = this.mc._results[i].nativeElement.value;
        }
        i++;
        if (this.mc._results[i].nativeElement.checked) {
          Ans = this.mc._results[i].nativeElement.value;
        }
      }
      else if (this.mc._results[i].nativeElement.type == 'file') {
        Ans = "";
        if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
          questionid = this.mc._results[i].nativeElement.id.split('_')[1]
        }
        if (this.mc._results[i].nativeElement.files[0] != undefined) {
          Ans = this.mc._results[i].nativeElement.files[0].name;
          this.logofile = this.mc._results[i].nativeElement.files[0];
          LogoFile = this.logofile;
        }
      }
      this.anslist.push({ QuestionId: questionid, AnswerText: Ans, UserId: this.userID, CreatedBy: this.userID });
    }
    // Save Formating 
    this._preferenceService.saveans(this.anslist, this.logofile, this.tokenKey).subscribe(
      data => {
        debugger
        if (data.status == 'Success') {
          if (this.logofile !== undefined) {
            //this.uploadFile(this.logofile, this.userID, res.logoFileName).subscribe();
            this._preferenceService.uploadFile(this.logofile, this.userID, data.logoFileName, this.tokenKey)
              .subscribe(data => {
                this._router.navigate(['/Hazard-Preference']);
              })
          }
          else {
            this._router.navigate(['/Hazard-Preference']);
          }
        }
        else {
          this.errorMessage = data.status;
          this.isshowerror = true;
          this.isShowprogressSpinner = false;
          this.unblockDocument();
        }
      }, error => {
        this.errorMessage = error;
        this.isshowerror = true;
        this.isShowprogressSpinner = false;
        this.unblockDocument();
        //this.errorMessage = error;                
      })
  }

  skip() {

    this.basicinfoForm = this._fb.group({
      UserPreferenceBasicInfoId: 0,
      CompanyName: [''],
      CompanyAddress: [''],
      City: [''],
      State: [''],
      Phone: [''],
      UserId: this.userID,
      CreatedBy: this.userID
    })
    // Save Basic Information
    this._preferenceService.savebasicinfo(this.basicinfoForm.value, this.tokenKey)
      .subscribe(data => {
        if (data.status == 'Success') {
        }
        else {
          this.errorMessage = data.status;
          this.isshowerror = true;
          this.isShowprogressSpinner = false;
          this.unblockDocument();
        }
      })

    this.anslist = [];
    for (let i = 0; i < this.mc._results.length; i++) {
      let questionid = 0;
      if (this.mc._results[i].nativeElement.id.split('_').length > 1) {
        questionid = this.mc._results[i].nativeElement.id.split('_')[1]
      }
      if (this.mc._results[i].nativeElement.type == 'radio') { i++; }
      //this.anslist.push({ QuestionId: questionid, AnswerText: "" });
      this.anslist.push({ QuestionId: questionid, AnswerText: "", UserId: this.userID, CreatedBy: this.userID });
    }
    // Save Formating
    this._preferenceService.saveans(this.anslist, this.logofile, this.tokenKey)
      .subscribe((data) => {
        if (data.status == 'Success') {
          this._router.navigate(['/Hazard-Preference']);
        }
        else {
          this.errorMessage = data.status;
          this.isshowerror = true;
          this.isShowprogressSpinner = false;
          this.unblockDocument();
        }
      }, error => {
        this.errorMessage = error;
        this.isshowerror = true;
        this.isShowprogressSpinner = false;
        this.unblockDocument();
      })
  }

  getQuestions() {
    this._preferenceService.getQuestions(1, this.tokenKey, this.userID).subscribe(
      //data => this.questionList = data.questionMaster
      data => {
        if (data.questionMaster != null) {
          this.questionList = data.questionMaster;
        }
        else {
          this.errorMessage = data.status;
          this.isshowerror = true;
          this.isShowprogressSpinner = false;
          this.unblockDocument();
        }
      },
      error => {
        console.log(JSON.stringify(error.json()));
      }
    )
  }

  remove_duplicates(arr) {
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
      obj[arr[i]] = true;
    }
    arr = [];
    for (let key in obj) {
      arr.push(key);
    }
    return arr;
  }

  logoradioChange(event) {
    let toArray = event.target.name.split("_");
    let conditionalid = 0;
    if (toArray.length > 1) {
      conditionalid = toArray[1];
      if (conditionalid > 0) {
        let ele = this.elRef.nativeElement.querySelector('.conditional_' + conditionalid);
        if (ele != null) {
          if (event.target.value.toLowerCase() == "yes") {
            this.elRef.nativeElement.querySelector('.conditional_' + conditionalid).hidden = false;
          }
          else {
            this.elRef.nativeElement.querySelector('.conditional_' + conditionalid).hidden = true;
          }
        }
      }
    }
  }

  fileExtension: any;
  fileEvent(event): any {
    //*-- this function gets content of uploaded file and validation -- * /
    var file = event.target.files[0];
    this.logofile = file.name;
    let size = Math.round(file.size / 1024);
    if (size <= 4000) {
      var allowedExtensions =
        ["gif", "jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "GIF"];
      this.fileExtension = this.logofile.split('.').pop();

      if (!this.isInArray(allowedExtensions, this.fileExtension)) {
        this.errorMessage = "You have selected an invalid image file type. EHS Plan Builder supports four image formats: GIF, PNG, JPEG, JPG.";
        this.isshowerror = true;
        //this.showError(this.errorMessage);
        window.scrollTo(0, 0);
      }
      else {
        this.errorMessage = "";
        this.isshowerror = false;
      }
    }
    else {
      this.errorMessage = "You have selected an larger image file. EHS Plan Builder supports file upto 4MB.";
      this.isshowerror = true;
      window.scrollTo(0, 0);
    }
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  GetCompany(): void {
    debugger;
    this.companyServices.GetCompanyFindByUserID(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["companyDetails"] != null && data["companyDetails"][0] != undefined) {
          let uPrefInfoId = parseInt(data["companyDetails"][0].userPreferenceBasicInfoId);
          if (uPrefInfoId > 0) {
            //this._router.navigate(['/Dashboard']);
            this.GetUserHazard();
          }
          else {
            this.getQuestions();
          }
        }
        else {
          this.getQuestions();
        }
      },
      error => this.errorMessage = error,
    );
  }

  GetUserHazard(): void {
    this.hazardServices.GetHazardMasterFindByUserID(this.tokenKey, this.userID, 0).subscribe(
      data => {
        if (data["hazardMaster"] != null && data["hazardMaster"] != undefined) {
          let obj = data["hazardMaster"].filter((item) => item.isSelected == true);
          if (obj.length > 0) {
            this._router.navigate(['/Dashboard']);
          }
          else {
            this._router.navigate(['/Hazard-Preference']);
          }
        }
      },
      error => this.errorMessage = error,
    );
  }
}

interface QuestionData {
  QuestionId: number;
  QuestionTitle: string;
  QuestionText: string;
  FieldTypeId: number;
  ConditionalQuestionId: number;
  GroupId: number;
  DisplayOrder: number;
  IsDeleted: boolean;
  FieldType: string;
  isShow: boolean;
  LookupData: LookupData;

}
interface LookupData {
  LookUpId: number;
  Name: string;
  Value: string;
  Type: string;
  IsDeleted: boolean
  DisplayOrder: number;
}
